<template>
    <div class="w-1/3 px-2">
        <div class="w-full pb-1 mt-3">
            <img class="w-full h-32 flex-shrink-0 object-cover object-left-top mx-auto"
                 :src="image"
                 alt="" />
        </div>
        <div class="flex justify-end items-center text-sm text-gray-500">
            <button type="button">
                <TrashIcon
                    @click="$emit('deleteImage')"
                    class="h-4 ml-4 w-4 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
            </button>
        </div>
    </div>
</template>

<script>
import { TrashIcon } from "@heroicons/vue/outline";
import CardButton from "@/Jetstream/CardButton";

export default {
    props: ["image"],
    emits: ["deleteImage"],
    components: { TrashIcon, CardButton }
};
</script>

<style scoped></style>
